export const APPLICATION_FOR_RESEARCH_TITLE = 'application_for_research_allowance';
export const APPLICATION_FOR_RESEARCH_BODY = 'application_for_research_allowance_body';
export const APPLICATION_ALLOWANCE_TABLE_INSTRUCTIONS = [{
  translationKey: 'for_the_financial_year',
  dataKey: 'elster_financial_year',
  shouldTranslateRightCell: false
}, {
  translationKey: 'tax_reference',
  dataKey: 'company_utr',
  shouldTranslateRightCell: false
}];
export const GENERAL_COMPANY_INFORMATION_TABLE_INSTRUCTIONS_ONE = [{
  translationKey: 'company_name',
  dataKey: 'company_name',
  shouldTranslateRightCell: false
}, {
  translationKey: 'location',
  dataKey: 'company_location',
  shouldTranslateRightCell: false
}, {
  translationKey: 'legal_form',
  dataKey: 'company_legal_form',
  shouldTranslateRightCell: true
}, {
  translationKey: 'industry',
  dataKey: 'company_industry',
  shouldTranslateRightCell: false
}, {
  translationKey: 'tax_group',
  dataKey: 'company_tax_group',
  shouldTranslateRightCell: false
}];
export const GENERAL_COMPANY_INFORMATION_TABLE_INSTRUCTIONS_TWO = [{
  translationKey: 'street',
  dataKey: 'company_street',
  shouldTranslateRightCell: false
}, {
  translationKey: 'company_house_number_with_supplement',
  dataKey: 'company_house_number_with_supplement',
  shouldTranslateRightCell: false
}, {
  translationKey: 'postal_code',
  dataKey: 'company_postcode',
  shouldTranslateRightCell: false
}, {
  translationKey: 'place',
  dataKey: 'company_location',
  shouldTranslateRightCell: false
}, {
  translationKey: 'country_in_case_of_foreign_countries',
  dataKey: 'company_country',
  shouldTranslateRightCell: false
}];
export const GENERAL_COMPANY_INFORMATION_TABLE_INSTRUCTIONS_THREE = [{
  translationKey: 'legal_rep_title',
  dataKey: 'company_legal_rep_title',
  shouldTranslateRightCell: false
}, {
  translationKey: 'legal_rep_last_name',
  dataKey: 'company_legal_rep_last_name',
  shouldTranslateRightCell: false
}, {
  translationKey: 'legal_rep_first_name',
  dataKey: 'company_legal_rep_first_name',
  shouldTranslateRightCell: false
}];
export const GENERAL_COMPANY_INFORMATION_TABLE_INSTRUCTIONS_FOUR = [{
  translationKey: 'gci_4_the_company_exempt',
  dataKey: 'company_tax_exemption',
  shouldTranslateRightCell: true
}, {
  translationKey: 'gci_4_the_research_and_dev',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}];
export const GENERAL_COMPANY_INFORMATION_TABLE_INSTRUCTIONS_FIVE_VERSION_7 = [{
  translationKey: 'is_an_affliated_company_within_the_meaning_of_3_paragraph',
  dataKey: 'is_an_affliated_company_within_the_meaning_of_3_paragraph',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'applied_or_will_for_a_research_allowance',
  dataKey: 'applied_or_will_for_a_research_allowance',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'max_elig_above_four_million',
  dataKey: 'max_elig_above_four_million',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'max_eligible_base_to_be_taken_into_account_for_request',
  dataKey: 'max_eligible_base_to_be_taken_into_account_for_request',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}];
export const GENERAL_COMPANY_INFORMATION_TABLE_INSTRUCTIONS_FIVE_VERSION_8 = [{
  translationKey: 'is_an_affliated_company_within_the_meaning_of_3_paragraph',
  dataKey: 'is_an_affliated_company_within_the_meaning_of_3_paragraph',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'applied_or_will_for_a_research_allowance',
  dataKey: 'applied_or_will_for_a_research_allowance',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'max_elig_above_four_million',
  dataKey: 'max_elig_above_four_million',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'max_elig_above_ten_million',
  dataKey: 'max_elig_above_ten_million',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'max_eligible_base_to_be_taken_into_account_for_request',
  dataKey: 'max_eligible_base_to_be_taken_into_account_for_request',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}];
export const GENERAL_COMPANY_INFORMATION_TABLE_INSTRUCTIONS_SIX = [{
  translationKey: 'affiliated_company_tax_number',
  dataKey: 'tax_number',
  shouldTranslateRightCell: false
}, {
  translationKey: 'affiliated_company_name',
  dataKey: 'name',
  shouldTranslateRightCell: false
}, {
  translationKey: 'maximum_eligible_assessment_basis',
  dataKey: 'maximum_eligible_assessment_basis',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'date_of_application',
  dataKey: 'date_of_application',
  shouldTranslateRightCell: false,
  fieldType: 'date'
}, {
  translationKey: 'date_of_the_decision',
  dataKey: 'date_of_the_decision',
  shouldTranslateRightCell: false,
  fieldType: 'date'
}];

// start of wage cost
// version 7
export const GENERAL_COMPANY_INFORMATION_TABLE_INSTRUCTIONS_SEVEN_VERSION_7 = [{
  translationKey: 'num_employees_in_enterprise_income_tax_is_deducted',
  dataKey: 'num_employees_in_enterprise_income_tax_is_deducted',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'num_employees_with_no_tax_deduction_due_to_dta',
  dataKey: 'num_employees_with_no_tax_deduction_due_to_dta',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'gross_wages_of_employees_for_whom_income_tax_is_deducted',
  dataKey: 'gross_wages_of_employees_for_whom_income_tax_is_deducted',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'gross_wages_employees_with_no_income_tax_due_to_dta',
  dataKey: 'gross_wages_employees_with_no_income_tax_due_to_dta',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'expenditure_to_secure_the_future_of_employees',
  dataKey: 'expenditure_to_secure_the_future_of_employees',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const GENERAL_COMPANY_INFORMATION_TABLE_INSTRUCTIONS_EIGHT_VERSION_7 = [{
  translationKey: 'num_employees_tax_deducted_by_full_time_eq',
  dataKey: 'num_employees_tax_deducted_by_full_time_eq',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'num_employees_with_no_tax_deduction_due_to_dta_by_full_time_eq',
  dataKey: 'num_employees_with_no_tax_deduction_due_to_dta_by_full_time_eq',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'gross_wages_employees_in_rd_projects_with_tax_deduct',
  dataKey: 'gross_wages_employees_in_rd_projects_with_tax_deduct',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'gross_wages_employees_with_no_income_tax_in_rd_due_to_dta',
  dataKey: 'gross_wages_employees_with_no_income_tax_in_rd_due_to_dta',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'expenditure_to_safeguard_the_future_of_employees_engaged_in_r_d',
  dataKey: 'expenditure_to_safeguard_the_future_of_employees_engaged_in_r_d',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];

// version 8
export const GENERAL_COMPANY_INFORMATION_TABLE_INSTRUCTIONS_SEVEN_VERSION_8 = [{
  translationKey: 'num_employees_in_enterprise_income_tax_is_deducted',
  dataKey: 'num_employees_in_enterprise_income_tax_is_deducted',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'num_employees_with_no_tax_deduction_due_to_dta',
  dataKey: 'num_employees_with_no_tax_deduction_due_to_dta',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'gross_wages_of_employees_for_whom_income_tax_is_deducted',
  dataKey: 'gross_wages_of_employees_for_whom_income_tax_is_deducted',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'gross_wages_employees_with_no_income_tax_due_to_dta',
  dataKey: 'gross_wages_employees_with_no_income_tax_due_to_dta',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'expenditure_to_secure_the_future_of_employees',
  dataKey: 'expenditure_to_secure_the_future_of_employees',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const GENERAL_COMPANY_INFORMATION_TABLE_INSTRUCTIONS_EIGHT_VERSION_8 = [{
  translationKey: 'num_employees_tax_deducted_by_full_time_eq',
  dataKey: 'num_employees_tax_deducted_by_full_time_eq',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'num_employees_full_time_eq_heads',
  dataKey: 'num_employees_full_time_eq_heads',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'num_employees_with_no_tax_deduction_due_to_dta_by_full_time_eq',
  dataKey: 'num_employees_with_no_tax_deduction_due_to_dta_by_full_time_eq',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'gross_wages_full_time_eq_heads',
  dataKey: 'gross_wages_full_time_eq_heads',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'gross_wages_employees_in_rd_projects_with_tax_deduct',
  dataKey: 'gross_wages_employees_in_rd_projects_with_tax_deduct',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'gross_wages_employees_with_no_income_tax_in_rd_due_to_dta',
  dataKey: 'gross_wages_employees_with_no_income_tax_in_rd_due_to_dta',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'expenditure_to_safeguard_the_future_of_employees_engaged_in_r_d',
  dataKey: 'expenditure_to_safeguard_the_future_of_employees_engaged_in_r_d',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
// end of wage cost

// partnership
export const GENERAL_COMPANY_INFORMATION_TABLE_INSTRUCTIONS_NINE = [{
  translationKey: 'salutation',
  dataKey: 'salutation',
  shouldTranslateRightCell: false
}, {
  translationKey: 'name_line_1',
  dataKey: 'name_line_1',
  shouldTranslateRightCell: false
}, {
  translationKey: 'name_line_2',
  dataKey: 'name_line_2',
  shouldTranslateRightCell: false
}, {
  translationKey: 'street',
  dataKey: 'street',
  shouldTranslateRightCell: false
}, {
  translationKey: 'house_number',
  dataKey: 'house_number',
  shouldTranslateRightCell: false
}, {
  translationKey: 'postal_code',
  dataKey: 'postal_code',
  shouldTranslateRightCell: false
}, {
  translationKey: 'place',
  dataKey: 'city',
  shouldTranslateRightCell: false
}];

// partnership parties
export const GENERAL_COMPANY_INFORMATION_TABLE_INSTRUCTIONS_TEN = [{
  translationKey: 'gci_10_number',
  dataKey: 'num_of_parties_involved',
  shouldTranslateRightCell: false
}, {
  translationKey: 'name',
  dataKey: 'name',
  shouldTranslateRightCell: false
}, {
  translationKey: 'forename',
  dataKey: 'forename',
  shouldTranslateRightCell: false
}, {
  translationKey: 'street',
  dataKey: 'street',
  shouldTranslateRightCell: false
}, {
  translationKey: 'house_number',
  dataKey: 'house_number',
  shouldTranslateRightCell: false
}, {
  translationKey: 'post_code',
  dataKey: 'postal_code',
  shouldTranslateRightCell: false
}, {
  translationKey: 'place',
  dataKey: 'city',
  shouldTranslateRightCell: false
}, {
  translationKey: 'tin',
  dataKey: 'tin',
  shouldTranslateRightCell: false
}, {
  translationKey: 'identification',
  dataKey: 'identification',
  shouldTranslateRightCell: false
}, {
  translationKey: 'type_of_participant',
  dataKey: 'type_of_participant',
  shouldTranslateRightCell: false
}];
export const GENERAL_COMPANY_INFORMATION_TABLE_INSTRUCTIONS_ELEVEN = [{
  translationKey: 'numerator_at_the_end_of_the_financial_year',
  dataKey: 'numerator_at_the_end_of_the_financial_year',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'denominator_at_the_end_of_the_financial_year',
  dataKey: 'denominator_at_the_end_of_the_financial_year',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
// end of partnership parties

export const IORADO_PROJECTS_ONE_VERSION_7 = [{
  translationKey: 'iorado_p_1_project_id',
  dataKey: 'application_number',
  shouldTranslateRightCell: false
}, {
  translationKey: 'company_unique_tax_reference_utr',
  dataKey: 'company_utr',
  shouldTranslateRightCell: false
}, {
  translationKey: 'full_project_name',
  dataKey: 'full_project_name',
  shouldTranslateRightCell: false
}, {
  translationKey: 'type_of_research',
  dataKey: 'type_of_research',
  shouldTranslateRightCell: true
}, {
  translationKey: 'ic_rd_project_will_carried_with_affiliated_companies',
  dataKey: 'ic_rd_project_will_carried_with_affiliated_companies',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'iorado_p_1_start_of_work',
  dataKey: 'project_start_date',
  shouldTranslateRightCell: false
}, {
  translationKey: 'iorado_p_1_the_decision_of_the',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'information_declared_has_not_changed',
  dataKey: 'information_declared_has_not_changed',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'further_funding_granted',
  dataKey: 'further_funding_granted',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}];
export const IORADO_PROJECTS_ONE_VERSION_8 = [{
  translationKey: 'iorado_p_1_project_id',
  dataKey: 'application_number',
  shouldTranslateRightCell: false
}, {
  translationKey: 'date_of_certification',
  dataKey: 'current_bsfz_response_date',
  shouldTranslateRightCell: false
}, {
  translationKey: 'company_unique_tax_reference_utr',
  dataKey: 'company_utr',
  shouldTranslateRightCell: false
}, {
  translationKey: 'full_project_name',
  dataKey: 'full_project_name',
  shouldTranslateRightCell: false
}, {
  translationKey: 'type_of_research',
  dataKey: 'type_of_research',
  shouldTranslateRightCell: false
}, {
  translationKey: 'ic_rd_project_will_carried_with_affiliated_companies',
  dataKey: 'ic_rd_project_will_carried_with_affiliated_companies',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'iorado_p_1_start_of_work',
  dataKey: 'project_start_date',
  shouldTranslateRightCell: false
}, {
  translationKey: 'iorado_p_1_the_decision_of_the',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'information_declared_has_not_changed',
  dataKey: 'information_declared_has_not_changed',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'further_funding_granted',
  dataKey: 'further_funding_granted',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}];
export const IORADO_PROJECTS_TWO = [{
  translationKey: 'iorado_p_2_the_research_and_development',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}];

// project detail listing part I
export const IORADO_PROJECTS_THREE_VERSION_7 = [{
  translationKey: 'iihrde_number_of_times_associated',
  dataKey: 'iihrde_number_of_times_associated',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'iihrde_corresponds_by_head',
  dataKey: 'iihrde_corresponds_by_head',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'iihrde_proportion_of_gross_wages_with_wage_tax',
  dataKey: 'iihrde_proportion_of_gross_wages_with_wage_tax',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'iihrde_gross_salary',
  dataKey: 'iihrde_gross_salary',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'of_which_received_by_employees_not_in_01jul2020till30jun2026',
  dataKey: 'iihrde_gs_received_by_employees_not_in_20_26',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'of_which_received_by_employees_30jun2020till01jul2026',
  dataKey: 'iihrde_gs_received_by_employees_in_20_26',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'iihrde_proportion_of_gross_wages_no_wage_tax',
  dataKey: 'iihrde_proportion_of_gross_wages_no_wage_tax',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'of_which_received_by_employees_not_in_01jul2020till30jun2026',
  dataKey: 'iihrde_pgs_not_in_20_26',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'of_which_received_by_employees_30jun2020till01jul2026',
  dataKey: 'iihrde_pgs_in_20_26',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'iihrde_prorota_expenditure',
  dataKey: 'iihrde_prorota_expenditure',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'iihrde_prorota_expenditure_not_in_20_26',
  dataKey: 'iihrde_prorota_expenditure_not_in_20_26',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'iihrde_prorota_expenditure_in_20_26',
  dataKey: 'iihrde_prorota_expenditure_in_20_26',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const IORADO_PROJECTS_THREE_VERSION_8 = [{
  translationKey: 'iihrde_number_of_times_associated',
  dataKey: 'iihrde_number_of_times_associated',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'iihrde_corresponds_by_head',
  dataKey: 'iihrde_corresponds_by_head',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'iihrde_proportion_of_gross_wages_with_wage_tax',
  dataKey: 'iihrde_proportion_of_gross_wages_with_wage_tax',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'iihrde_gross_salary',
  dataKey: 'iihrde_gross_salary',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'of_which_received_by_employees_before_28mar2024',
  dataKey: 'iihrde_gs_received_by_employees_before_28_03_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'of_which_received_by_employees_after_27mar2024',
  dataKey: 'iihrde_gs_received_by_employees_after_27_03_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'iihrde_proportion_of_gross_wages_no_wage_tax',
  dataKey: 'iihrde_proportion_of_gross_wages_no_wage_tax',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'of_which_received_by_employees_before_28mar2024',
  dataKey: 'iihrde_pgs_not_before_28_03_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'of_which_received_by_employees_after_27mar2024',
  dataKey: 'iihrde_pgs_in_after_27_03_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'iihrde_prorota_expenditure',
  dataKey: 'iihrde_prorota_expenditure',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'of_which_received_by_employees_before_28mar2024',
  dataKey: 'iihrde_prorota_expenditure_before_28_03_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'of_which_received_by_employees_after_27mar2024',
  dataKey: 'iihrde_prorota_expenditure_after_27_03_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const IORADO_PROJECTS_FOUR_VERSION_7 = [{
  translationKey: 'ocp_research_carried_out',
  dataKey: 'ocp_research_carried_out',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'ocsp_working_hours',
  dataKey: 'ocsp_working_hours',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'of_which_carried_out_not_in30jun2020till01jul2026',
  dataKey: 'ocsp_working_hours_not_in_20_26',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'of_which_carried_out_in30jun2020till01jul2026',
  dataKey: 'ocsp_working_hours_in_20_26',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const IORADO_PROJECTS_FOUR_VERSION_8 = [{
  translationKey: 'ocp_research_carried_out',
  dataKey: 'ocp_research_carried_out',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'ocsp_working_hours',
  dataKey: 'ocsp_working_hours',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'of_which_carried_out_before28mar2024',
  dataKey: 'ocsp_working_hours_before_28_03_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'of_which_carried_out_after_27mar2024',
  dataKey: 'ocsp_working_hours_after_27_03_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
// end of project detail listing part I

export const IORADO_PROJECTS_FIVE_VERSION_7 = [
// shareholders
{
  translationKey: 'name_shareholder',
  dataKey: 'name',
  shouldTranslateRightCell: false
}, {
  translationKey: 'ocsce_is_civil_agreement',
  dataKey: 'ocsce_is_civil_agreement',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'ocsce_total_remun_for_shareholders',
  dataKey: 'ocsce_total_remun_for_shareholders',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'ocsce_total_remun_for_project',
  dataKey: 'ocsce_total_remun_for_project',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'ocsce_total_working_hours_shareholder_on_project',
  dataKey: 'ocsce_total_working_hours_shareholder_on_project',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'of_which_carried_out_not_in30jun2020till01jul2026',
  dataKey: 'ocsce_total_wh_shareholder_not_in_20_26',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'of_which_carried_out_in30jun2020till01jul2026',
  dataKey: 'ocsce_total_wh_shareholder_in_20_26',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const IORADO_PROJECTS_FIVE_VERSION_8 = [
// shareholders
{
  translationKey: 'name_shareholder',
  dataKey: 'name',
  shouldTranslateRightCell: false
}, {
  translationKey: 'ocsce_is_civil_agreement',
  dataKey: 'ocsce_is_civil_agreement',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'ocsce_total_remun_for_shareholders',
  dataKey: 'ocsce_total_remun_for_shareholders',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'ocsce_total_remun_for_project',
  dataKey: 'ocsce_total_remun_for_project',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'ocsce_total_working_hours_shareholder_on_project',
  dataKey: 'ocsce_total_working_hours_shareholder_on_project',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'of_which_carried_out_before28mar2024',
  dataKey: 'ocsce_total_wh_shareholder_before_28_03_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'of_which_carried_out_after_27mar2024',
  dataKey: 'ocsce_total_wh_shareholder_after_27_03_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const IORADO_PROJECTS_SIX = [
// only for contract research 
{
  translationKey: 'iorado_p_6_1',
  dataKey: 'DEFINE_LATER',
  shouldTranslateRightCell: false
}, {
  translationKey: 'iorado_p_6_2',
  dataKey: 'DEFINE_LATER',
  shouldTranslateRightCell: false
}, {
  translationKey: 'iorado_p_6_3',
  dataKey: 'DEFINE_LATER',
  shouldTranslateRightCell: false
}, {
  translationKey: 'iorado_p_6_4',
  dataKey: 'DEFINE_LATER',
  shouldTranslateRightCell: false
}, {
  translationKey: 'further_funding_applied_or_granted_for_rd',
  dataKey: 'further_funding_applied_or_granted_for_rd',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}];
export const IORADO_PROJECTS_SEVEN = [
// Daten des Auftragnehmers || contractors_data
{
  translationKey: 'iorado_p_7_1',
  dataKey: 'default_field_consent_is_granted',
  shouldTranslateRightCell: true
}, {
  translationKey: 'research_institute_name',
  dataKey: 'research_institute_name',
  shouldTranslateRightCell: false
}, {
  translationKey: 'street',
  dataKey: 'street',
  shouldTranslateRightCell: false
}, {
  translationKey: 'house_number',
  dataKey: 'house_number',
  shouldTranslateRightCell: false
}, {
  translationKey: 'additional_house_number_details',
  dataKey: 'additional_house_number_details',
  shouldTranslateRightCell: false
}, {
  translationKey: 'postal_code',
  dataKey: 'postcode',
  shouldTranslateRightCell: false
}, {
  translationKey: 'place',
  dataKey: 'country',
  shouldTranslateRightCell: true
}, {
  translationKey: 'tax_number',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'state',
  dataKey: 'state_of_tax_office',
  shouldTranslateRightCell: true
}];
export const IORADO_PROJECTS_EIGHT = [
// Only when receiving or applying for other subsidies  
{
  translationKey: 'approval_date',
  dataKey: 'approval_date',
  shouldTranslateRightCell: false,
  fieldType: 'date'
}, {
  translationKey: 'funding_body',
  dataKey: 'funding_body',
  shouldTranslateRightCell: false
}, {
  translationKey: 'grant_amount',
  dataKey: 'grant_amount',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];

// Asset constant here
export const IORADO_PROJECTS_ASSET_TABLE_ONE = [{
  translationKey: 'a1_type_and_description',
  dataKey: 'a1_type_and_description',
  shouldTranslateRightCell: false
}, {
  translationKey: 'a2_asset_after_20240327',
  dataKey: 'a2_asset_after_20240327',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'a3_acquisition_date',
  dataKey: 'a3_acquisition_date',
  shouldTranslateRightCell: false,
  fieldType: 'date'
}, {
  translationKey: 'a4_needed_for_rd',
  dataKey: 'a4_needed_for_rd',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'a5_movable',
  dataKey: 'a5_movable',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'a6_belongs_to_fixed_asset',
  dataKey: 'a6_belongs_to_fixed_asset',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'a7_internal_only',
  dataKey: 'a7_internal_only',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'a8_used_for_fiscal_year_and_rd',
  dataKey: 'a8_used_for_fiscal_year_and_rd',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'a9_number_of_months_not_exclusive_for_rd',
  dataKey: 'a9_number_of_months_not_exclusive_for_rd',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'a10_was_asset_sold_in_this_fiscal_year',
  dataKey: 'a10_was_asset_sold_in_this_fiscal_year',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'a11_value_at_time_of_sale',
  dataKey: 'a11_value_at_time_of_sale',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'a12_date_of_sale',
  dataKey: 'a12_date_of_sale',
  shouldTranslateRightCell: false,
  fieldType: 'date'
}, {
  translationKey: 'a13_acquisition_cost',
  dataKey: 'a13_acquisition_cost',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'a14_formed_under_estg',
  dataKey: 'a14_formed_under_estg',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'a15_value_at_end_of_previous_fiscal_year',
  dataKey: 'a15_value_at_end_of_previous_fiscal_year',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'a16_value_at_end_of_this_fiscal_year',
  dataKey: 'a16_value_at_end_of_this_fiscal_year',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'a17_additional_funding_applied_or_granted',
  dataKey: 'a17_additional_funding_applied_or_granted',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}];
export const IORADO_PROJECTS_ASSET_TABLE_TWO = [{
  translationKey: 'b1_difference_acquisition_production',
  dataKey: 'b1_difference_acquisition_production',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'b2_less_pro_rata_conditions_inclusion',
  dataKey: 'b2_less_pro_rata_conditions_inclusion',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'b3_less_expenses_other_funding',
  dataKey: 'b3_less_expenses_other_funding',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'b4_difference_acquisition_production_costs_value_end_fiscal_year',
  dataKey: 'b4_difference_acquisition_production_costs_value_end_fiscal_year',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}];
export const IORADO_PROJECTS_ASSET_TABLE_THREE = [{
  translationKey: 'c1_difference_value_end_previous_fiscal_year',
  dataKey: 'c1_difference_value_end_previous_fiscal_year',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'c2_less_prorated_conditions_inclusion_exclusive_use',
  dataKey: 'c2_less_prorated_conditions_inclusion_exclusive_use',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'c3_less_expenses_other_funding_claimed',
  dataKey: 'c3_less_expenses_other_funding_claimed',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'c4_difference_value_end_previous_fiscal_year_value_end_fiscal_year',
  dataKey: 'c4_difference_value_end_previous_fiscal_year_value_end_fiscal_year',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}];
// End of asset constants

export const IORADO_PROJECTS_NINE = [
// Only for cooperation projects
{
  translationKey: 'iorado_p_9_1',
  dataKey: 'ic_rd_project_will_carried_with_affiliated_companies',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'iorado_p_9_2',
  dataKey: 'ic_prop_carried_in_affiliated_companies',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'iorado_p_9_3',
  dataKey: 'ic_rd_project_is_carried_with_taxexempt_research_institutions',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'iorado_p_9_4',
  dataKey: 'ic_prop_carried_in_taxexempt_inst',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}, {
  translationKey: 'iorado_p_9_5',
  dataKey: 'ic_rd_project_will_carried_with_other_taxable_comapnies',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'iorado_p_9_6',
  dataKey: 'ic_prop_carried_in_other_taxable_companies',
  shouldTranslateRightCell: false,
  fieldType: 'decimal'
}];

// project detail listing parth II
// version 7 projects table 10 & 11
export const IORADO_PROJECTS_TEN = [
// Determination of the assessment basis for eligible expenses incurred before 01.07.202 
{
  translationKey: 'b1_sum_wages_own_employees_before',
  dataKey: 'b1_sum_wages_own_employees_before',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'less_expenditure_other_funding_claimed_before_2020',
  dataKey: 'less_expenditure_other_funding_claimed_before_2020',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'calc_eligible_expenses_wages_own_employees_1_version_7',
  dataKey: 'calc_eligible_expenses_wages_own_employees_1_version_7',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const IORADO_PROJECTS_ELEVEN = [
// Ermittlung der Bemessungsgrundlage für förderfähige Aufwendungen, die nach dem 30.06.2020 entstanden sind  
{
  translationKey: 'd1_sum_wages_own_employees_after',
  dataKey: 'd1_sum_wages_own_employees_after',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'less_expenditure_other_funding_claimed_after_2020',
  dataKey: 'less_expenditure_other_funding_claimed_after_2020',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'calc_eligible_expenses_wages_own_employees_2_version_7',
  dataKey: 'calc_eligible_expenses_wages_own_employees_2_version_7',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];

// version 8 projects table 10 & 11
export const IORADO_PROJECTS_TEN_VERSION_8 = [
// Determination of the assessment basis for eligible expenses incurred before 01.07.202 
{
  translationKey: 'b1_sum_wages_own_employees_before',
  dataKey: 'b1_sum_wages_own_employees_before',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'less_expenditure_other_funding_claimed_before_2024',
  dataKey: 'less_expenditure_other_funding_claimed_before_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'calc_eligible_expenses_wages_own_employees_1_version_8',
  dataKey: 'calc_eligible_expenses_wages_own_employees_1_version_8',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const IORADO_PROJECTS_ELEVEN_VERSION_8 = [
// Ermittlung der Bemessungsgrundlage für förderfähige Aufwendungen, die nach dem 30.06.2020 entstanden sind  
{
  translationKey: 'd1_sum_wages_own_employees_after',
  dataKey: 'd1_sum_wages_own_employees_after',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'less_expenditure_other_funding_claimed_after_2024',
  dataKey: 'less_expenditure_other_funding_claimed_after_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'calc_eligible_expenses_wages_own_employees_2_version_8',
  dataKey: 'calc_eligible_expenses_wages_own_employees_2_version_8',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
// end of project detail listing part II

export const DMVER_ONE = [
// Deminis Verodnung
{
  translationKey: 'dmver_1_1',
  dataKey: 'deminimies_ver',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}];
export const DMVER_SUBSIDY = [
// Erklärung der De-minimis-Beihilfen
{
  translationKey: 'subsidy_date',
  dataKey: 'subsidy_date',
  shouldTranslateRightCell: false,
  fieldType: 'date'
}, {
  translationKey: 'aid_providers',
  dataKey: 'aid_providers',
  shouldTranslateRightCell: false
}, {
  translationKey: 'aid_value',
  dataKey: 'aid_value',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];

// further requirements section 4 version 7
export const FURTHER_REQUIREMENTS_ONE_VERSION_7 = [
// Further requirements under European state aid law
{
  translationKey: 'fr_1_1',
  dataKey: 'fr_1_1',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'fr_1_2',
  dataKey: 'fr_1_2',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'fr_1_3',
  dataKey: 'fr_1_3',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}];

// further requirements section 4 version 8
export const FURTHER_REQUIREMENTS_ONE_VERSION_8 = [{
  translationKey: 'fr_1_1',
  dataKey: 'fr_1_1',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'fr_1_2',
  dataKey: 'fr_1_2',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'fr_1_3_v8',
  dataKey: 'fr_1_3',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'fr_1_4',
  dataKey: 'fr_1_4',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}];
export const FURTHER_REQUIREMENTS_TWO_VERSION_8 = [{
  translationKey: 'fr_1_5',
  dataKey: 'fr_1_5',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'fr_1_6',
  dataKey: 'fr_1_6',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'fr_1_7',
  dataKey: 'fr_1_7',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'fr_1_8',
  dataKey: 'fr_1_8',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'fr_1_9',
  dataKey: 'fr_1_9',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'fr_1_10',
  dataKey: 'fr_1_10',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}];
// end of further requirements section 4

export const DETERMINATION_OF_ASSESSMENT_ONE_VERSION_7 = [
// Förderfähige Aufwendungen aus eigenbetrieblichen Forschungs- und Entwicklungsvorhaben: Arbeitslöhne
{
  translationKey: 'eligible_expenses_from_wages_own_employees_before_jul_2020',
  dataKey: 'eligible_expenses_from_wages_own_employees_before_jul_2020',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const DETERMINATION_OF_ASSESSMENT_ONE_VERSION_8 = [
// Förderfähige Aufwendungen aus eigenbetrieblichen Forschungs- und Entwicklungsvorhaben: Arbeitslöhne
{
  translationKey: 'eligible_expenses_from_wages_own_employees_before_mar_2024',
  dataKey: 'eligible_expenses_from_wages_own_employees_before_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const DETERMINATION_OF_ASSESSMENT_TWO_VERSION_7 = [
// Eligible expenses from in-house research and development projects: Own contributions by a sole proprietor or by partners of a co-entrepreneurship 
{
  translationKey: 'declared_working_hours_sole_proprietor_before_jul_2020',
  dataKey: 'declared_working_hours_sole_proprietor_before_jul_2020',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'max_eligible_hours_sole_proprietor_before_jul_2020',
  dataKey: 'max_eligible_hours_sole_proprietor_before_jul_2020',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'declared_working_hours_co_entrepreneurship_partners_before_jul_2020',
  dataKey: 'declared_working_hours_co_entrepreneurship_partners_before_jul_2020',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'max_eligible_hours_co_entrepreneurship_partners_before_jul_2020',
  dataKey: 'max_eligible_hours_co_entrepreneurship_partners_before_jul_2020',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'total_eligible_expenses_own_contributions_before_jul_2020',
  dataKey: 'total_eligible_expenses_own_contributions_before_jul_2020',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const DETERMINATION_OF_ASSESSMENT_TWO_VERSION_8 = [
// Eligible expenses from in-house research and development projects: Own contributions by a sole proprietor or by partners of a co-entrepreneurship 
{
  translationKey: 'declared_working_hours_sole_proprietor_before_mar_2024',
  dataKey: 'declared_working_hours_sole_proprietor_before_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'max_eligible_hours_sole_proprietor_before_mar_2024',
  dataKey: 'max_eligible_hours_sole_proprietor_before_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'declared_working_hours_co_entrepreneurship_partners_before_mar_2024',
  dataKey: 'declared_working_hours_co_entrepreneurship_partners_before_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'max_eligible_hours_co_entrepreneurship_partners_before_mar_2024',
  dataKey: 'max_eligible_hours_co_entrepreneurship_partners_before_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'total_eligible_expenses_own_contributions_before_mar_2024',
  dataKey: 'total_eligible_expenses_own_contributions_before_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const DETERMINATION_OF_ASSESSMENT_THREE_VERSION_7 = [
// Eligible expenditure from contract research
{
  translationKey: 'total_remuneration_contract_research_before_jul_2020',
  dataKey: 'total_remuneration_contract_research_before_jul_2020',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'of_which_sixty_percent_eligible',
  dataKey: 'contract_research_sixty_percent_eligible_before_jul_2020',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const DETERMINATION_OF_ASSESSMENT_THREE_VERSION_8 = [
// Eligible expenditure from contract research
{
  translationKey: 'total_remuneration_contract_research_before_mar_2024',
  dataKey: 'total_remuneration_contract_research_before_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'of_which_sixty_percent_eligible',
  dataKey: 'contract_research_sixty_percent_eligible_before_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const DETERMINATION_OF_ASSESSMENT_FOUR_VERSION_7 = [
// Subtotal of eligible expenses incurred after 01.01.2020 and before 01.07.2020
{
  translationKey: 'subtotal_eligible_expenses_before_jul_2020',
  dataKey: 'subtotal_eligible_expenses_before_jul_2020',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const DETERMINATION_OF_ASSESSMENT_FOUR_VERSION_8 = [
// Subtotal of eligible expenses incurred after 01.01.2020 and before 01.07.2020
{
  translationKey: 'subtotal_eligible_expenses_before_mar_2024',
  dataKey: 'subtotal_eligible_expenses_before_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const DETERMINATION_OF_ASSESSMENT_FIVE_VERSION_7 = [
// Eligible expenditure from in-house research and development projects: Wages
{
  translationKey: 'eligible_expenses_from_wages_own_employees_after_jun_2020',
  dataKey: 'eligible_expenses_from_wages_own_employees_after_jun_2020',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const DETERMINATION_OF_ASSESSMENT_FIVE_VERSION_8 = [
// Eligible expenditure from in-house research and development projects: Wages
{
  translationKey: 'eligible_expenses_from_wages_own_employees_after_mar_2024',
  dataKey: 'eligible_expenses_from_wages_own_employees_after_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const DETERMINATION_OF_ASSESSMENT_SIX_VERSION_7 = [
// Eligible expenses from in-house research and development projects: Own contributions by a sole proprietor or by partners of a co-entrepreneurship
{
  translationKey: 'declared_working_hours_sole_proprietor_after_jun_2020',
  dataKey: 'declared_working_hours_sole_proprietor_after_jun_2020',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'max_eligible_hours_sole_proprietor_after_jun_2020',
  dataKey: 'max_eligible_hours_sole_proprietor_after_jun_2020',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'declared_working_hours_co_entrepreneurship_partners_after_jun_2020',
  dataKey: 'declared_working_hours_co_entrepreneurship_partners_after_jun_2020',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'max_eligible_hours_co_entrepreneurship_partners_after_jun_2020',
  dataKey: 'max_eligible_hours_co_entrepreneurship_partners_after_jun_2020',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'total_eligible_expenses_own_contributions_after_jun_2020',
  dataKey: 'total_eligible_expenses_own_contributions_after_jun_2020',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const DETERMINATION_OF_ASSESSMENT_SIX_VERSION_8 = [
// Eligible expenses from in-house research and development projects: Own contributions by a sole proprietor or by partners of a co-entrepreneurship
{
  translationKey: 'declared_working_hours_sole_proprietor_after_mar_2024',
  dataKey: 'declared_working_hours_sole_proprietor_after_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'max_eligible_hours_sole_proprietor_after_mar_2024',
  dataKey: 'max_eligible_hours_sole_proprietor_after_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'declared_working_hours_co_entrepreneurship_partners_after_mar_2024',
  dataKey: 'declared_working_hours_co_entrepreneurship_partners_after_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'max_eligible_hours_co_entrepreneurship_partners_after_mar_2024',
  dataKey: 'max_eligible_hours_co_entrepreneurship_partners_after_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'total_eligible_expenses_own_contributions_after_mar_2024',
  dataKey: 'total_eligible_expenses_own_contributions_after_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const DETERMINATION_OF_ASSESSMENT_SIX_B_VERSION_8 = [
// Eligible expenses from in-house research and development projects: Own contributions by a sole proprietor or by partners of a co-entrepreneurship
{
  translationKey: 'total_depreciable_assets_acquisition_production_cost_difference_after_mar_2024',
  dataKey: 'total_depreciable_assets_acquisition_production_cost_difference_after_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'total_depreciable_assets_prior_year_end_value_difference_after_mar_2024',
  dataKey: 'total_depreciable_assets_prior_year_end_value_difference_after_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const DETERMINATION_OF_ASSESSMENT_SEVEN_VERSION_7 = [
// Förderfähige Aufwendungen aus Auftragsforschung
{
  translationKey: 'total_remuneration_contract_research_after_jun_2020',
  dataKey: 'total_remuneration_contract_research_after_jun_2020',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'of_which_sixty_percent_eligible',
  dataKey: 'contract_research_sixty_percent_eligible_after_jun_2020',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const DETERMINATION_OF_ASSESSMENT_SEVEN_VERSION_8 = [
// Förderfähige Aufwendungen aus Auftragsforschung
{
  translationKey: 'total_remuneration_contract_research_after_mar_2024',
  dataKey: 'total_remuneration_contract_research_after_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'contract_research_sixty_percent_eligible_contract_awarded_before_mar_2024',
  dataKey: 'contract_research_sixty_percent_eligible_contract_awarded_before_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'contract_research_seventy_percent_eligible_contract_awarded_after_mar_2024',
  dataKey: 'contract_research_seventy_percent_eligible_contract_awarded_after_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const DETERMINATION_OF_ASSESSMENT_EIGHT_VERSION_7 = [
// Subtotal of eligible expenses incurred after 30.06.2020
{
  translationKey: 'subtotal_eligible_expenses_after_jun_2020',
  dataKey: 'subtotal_eligible_expenses_after_jun_2020',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const DETERMINATION_OF_ASSESSMENT_EIGHT_VERSION_8 = [
// Subtotal of eligible expenses incurred after 30.06.2020
{
  translationKey: 'subtotal_eligible_expenses_after_mar_2024',
  dataKey: 'subtotal_eligible_expenses_after_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const DETERMINATION_OF_ASSESSMENT_NINE_VERSION_7 = [
// 1.3 Determination of the eligible assessment basis for the respective financial year
{
  translationKey: 'eligible_expenses_before_jul_2020_capped_at_2m',
  dataKey: 'eligible_expenses_before_jul_2020_capped_at_2m',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'total_eligible_expenses_before_jul_2020_and_after_jun_2020',
  dataKey: 'total_eligible_expenses_before_jul_2020_and_after_jun_2020',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'eligible_assessment_basis_capped_at_4m',
  dataKey: 'eligible_assessment_basis_capped_at_4m',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'dos_9_4_v7',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}];
export const DETERMINATION_OF_ASSESSMENT_NINE_VERSION_8 = [
// 1.3 Determination of the eligible assessment basis for the respective financial year
{
  translationKey: 'eligible_expenses_before_mar_2024_capped_at_4m',
  dataKey: 'eligible_expenses_before_mar_2024_capped_at_4m',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'total_eligible_expenses_before_mar_2024_and_after_mar_2024',
  dataKey: 'total_eligible_expenses_before_mar_2024_and_after_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}, {
  translationKey: 'eligible_assessment_basis_capped_at_10m',
  dataKey: 'eligible_assessment_basis_capped_at_10m',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const DETERMINATION_OF_ASSESSMENT_TEN_VERSION_7 = [
// Determination of the research allowance applied for 
{
  translationKey: 'requested_research_allowance',
  dataKey: 'requested_research_allowance',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const DETERMINATION_OF_ASSESSMENT_TEN_VERSION_8 = [
// Determination of the research allowance applied for 
{
  translationKey: 'sme_criteria_met_increased_funding_rate_applied_after_mar_2024',
  dataKey: 'sme_criteria_met_increased_funding_rate_applied_after_mar_2024',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'requested_research_allowance',
  dataKey: 'requested_research_allowance',
  shouldTranslateRightCell: false,
  fieldType: 'integer'
}];
export const DETERMINATION_OF_ASSESSMENT_ELEVEN_VERSION_7 = [
// De minimis examination for eligible expenses from own contributions
{
  translationKey: 'dos_11_1_v7',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'dos_11_2_v7',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'dos_11_3',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}];
export const DETERMINATION_OF_ASSESSMENT_ELEVEN_VERSION_8 = [
// De minimis examination for eligible expenses from own contributions
{
  translationKey: 'dos_11_1_v8',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'dos_11_2_v8',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'dos_11_3',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}];
export const DETERMINATION_OF_ASSESSMENT_TWELVE_VERSION_7 = [
// Determination of the aid value without limitation to a maximum basis of assessment
{
  translationKey: 'dos_12_1',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'dos_12_2',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'dos_12_4',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'dos_12_5',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'dos_12_6',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}];
export const DETERMINATION_OF_ASSESSMENT_TWELVE_VERSION_8 = [
// Determination of the aid value without limitation to a maximum basis of assessment
{
  translationKey: 'dos_12_1',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'dos_12_2',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'dos_12_3_v8',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'dos_12_4',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'dos_12_5',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'dos_12_6',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}];
export const FINAL_DECLARATION_ONE = [
// Final Declaration 6, table 1
{
  translationKey: 'final_declaration_1',
  dataKey: 'finalDeclarationOneHardcodedValue',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}, {
  translationKey: 'final_declaration_2',
  dataKey: 'finalDeclarationTwoHardcodedValue',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}];
export const PARTICIPATION_ONE = [
// Participation in the preparation of this application 7, table 1
{
  translationKey: 'participation_1_1',
  dataKey: 'participationOneHardcodedValue',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}];
export const PARTICIPATION_TWO = [
// Participation in the preparation of this application 7, table 2
{
  translationKey: 'name',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'forename',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'street',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'house_number',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'postal_code',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'ort',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'phone_number',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'adiitional_information',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'mandator_number',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}, {
  translationKey: 'editor_identifier',
  dataKey: 'NOT_EXIST',
  shouldTranslateRightCell: false
}];
export const POWER_OF_ATTORNEY_ONE = [
// Power of Attorney 8, table 1
{
  translationKey: 'research_allowance_should_be_send_different_recipient',
  dataKey: 'research_allowance_should_be_send_different_recipient',
  shouldTranslateRightCell: false,
  fieldType: 'yes_no'
}];
export const POWER_OF_ATTORNEY_TWO = [
// Power of Attorney 8, table 2
{
  translationKey: 'salutation',
  dataKey: 'salutation',
  shouldTranslateRightCell: false
}, {
  translationKey: 'name_line_1',
  dataKey: 'name_line_1',
  shouldTranslateRightCell: false
}, {
  translationKey: 'name_line_2',
  dataKey: 'name_line_2',
  shouldTranslateRightCell: false
}, {
  translationKey: 'street',
  dataKey: 'street',
  shouldTranslateRightCell: false
}, {
  translationKey: 'house_number',
  dataKey: 'house_number',
  shouldTranslateRightCell: false
}, {
  translationKey: 'postal_code_domestic',
  dataKey: 'postal_code_domestic',
  shouldTranslateRightCell: false
}, {
  translationKey: 'city',
  dataKey: 'city',
  shouldTranslateRightCell: false
}, {
  translationKey: 'postal_code_foreign',
  dataKey: 'postal_code_foreign',
  shouldTranslateRightCell: false
}, {
  translationKey: 'state',
  dataKey: 'state',
  shouldTranslateRightCell: false
}];